<template>
  <el-dialog
    append-to-body
    :visible.sync="innerVisible"
    :title="title"
    width="400px"
    class="station-edit-dialog"
    :close-on-click-modal="false"
  >
    <div v-if="innerVisible" class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="110px" label-position="left">
        <el-form-item :label="$t('baseInfo.overseaWarehouse.warehouseCode')" required>
          <el-input v-model="form.warehouseCode" v-uppercase :disabled="!isAdmin && form.ifFba" :no="'warehouseCode'" style="width: 200px" />
        </el-form-item>
        <el-form-item v-if="!isAdmin && !form.ifFba" :label="$t('baseInfo.overseaWarehouse.countryChineseName')" required>
          <el-input v-model="form.countryChineseName" v-uppercase :no="'countryChineseName'" style="width: 200px" />
        </el-form-item>
        <el-form-item v-if="!isAdmin && !form.ifFba" :label="$t('baseInfo.overseaWarehouse.countryEnglishName')" required>
          <el-input v-model="form.countryEnglishName" v-uppercase :no="'countryEnglishName'" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.country')" required>
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_Country"
            :cache="false"
            :no="'country'"
            filterable
            :callback-params="{key:'countryCode'}"
            callback-method-type="value"
            :default-value="form.countryCode"
            :static-options="countryList"
            style="width:200px;"
            :disabled="!isAdmin && form.ifFba"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.province')">
          <el-input v-model="form.province" v-uppercase :disabled="!isAdmin && form.ifFba" :no="'province'" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.city')" required>
          <el-input v-model="form.cityName" disabled :no="'city'" style="width: 200px;margin-right: 5px" />
          <el-button type="primary" :no="'cityBtn'" :disabled="!isAdmin && form.ifFba" @click="cityClickHandler">...</el-button>
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.zipCode')" required>
          <el-input v-model="form.zipCode" :no="'zipCode'" :disabled="!isAdmin && form.ifFba" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.ifFba')">
          <el-checkbox v-model="form.ifFba" :no="'ifFba'" disabled />
        </el-form-item>
        <el-form-item v-if="!isAdmin && !form.ifFba" :label="$t('baseInfo.overseaWarehouse.warehouseAgeCalculationRulesEdit')">
          <cargo-advance-select
            no="warehouseAgeCalculationRules"
            filterable
            :select-type="selectTypeNames.local_cache_FbaJobConstants$WAREHOUSE_AGE_CALCULATION_RULES"
            callback-method-type="value"
            :default-value="form.warehouseAgeCalculationRules"
            :callback-params="{key:'warehouseAgeCalculationRules'}"
            :clearable="false"
            style="width: 200px"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.address')" required>
          <el-input v-model="form.address1" v-uppercase :no="'address'" :disabled="!isAdmin && form.ifFba" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.overseaWarehouse.entryRequirements')">
          <el-input v-model="form.entryRequirements" :no="'entryRequirements'" :disabled="!isAdmin && form.ifFba" style="width: 200px" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button type="primary" :no="'save'" @click="save">{{ $t('common.btn.save') }}</el-button>
      <el-button :no="'cancel'" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
    <location-search-dialog
      :visible.sync="cityDialogVisible"
      @addCallBack="selectLocalHandler"
      @close="cityDialogVisible=false"
    />
  </el-dialog>
</template>

<script>
import { getCountryList } from '@/api/country'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocationSearchDialog from '@/views/cargo/v0/Information/components/LocationSearchDialog'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { save } from '@/api/basicData/overseaWarehouse'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'OverseaWarehouseEditDialog',
  components: { LocationSearchDialog, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    tenantId: { type: Number, required: true },
    overseaWarehouse: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      isAdmin: this.$store.getters.tenantId === 1,
      selectTypeNames: TYPE_NAMES,
      baseForm: {
        uuid: '',
        warehouseCode: '',
        countryChineseName: '',
        countryEnglishName: '',
        countryCode: '',
        province: '',
        cityCode: '',
        cityName: '',
        zipCode: '',
        ifFba: false,
        address1: '',
        entryRequirements: '',
        warehouseAgeCalculationRules: 6
      },
      form: {
        uuid: '',
        warehouseCode: '',
        countryChineseName: '',
        countryEnglishName: '',
        countryCode: '',
        province: '',
        cityCode: '',
        cityName: '',
        zipCode: '',
        ifFba: false,
        address1: '',
        entryRequirements: '',
        warehouseAgeCalculationRules: 6
      },
      cityDialogVisible: false,
      location: null,
      countryList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      Object.assign(this.form, this.baseForm)
      if (newVal && this.overseaWarehouse) {
        Object.assign(this.form, this.overseaWarehouse)
      }
      if (!this.overseaWarehouse) {
        this.form.ifFba = this.isAdmin
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeCreate() {
    getCountryList().then(res => {
      this.countryList = res.data
    })
  },
  methods: {
    selectCargoItem(item) {
      this.form[item.key] = item.value
    },
    cityClickHandler() {
      this.cityDialogVisible = true
    },
    selectLocalHandler(location) {
      this.location = location
      this.form.cityName = location.englishName
      this.form.cityCode = location.code
    },
    save() {
      if (!this.checkSave()) {
        return
      }
      this.form.tenantId = this.tenantId
      if (this.isAdmin) {
        this.form.countryChineseName = undefined
        this.form.countryEnglishName = undefined
        this.form.warehouseAgeCalculationRules = undefined
      }
      save(this.form).then(resp => {
        this.$emit('saveCallBack', resp.data)
        syncSpecificBasicData(basicCacheKeys.basic_data_OverseaWarehouse)
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.$emit('close')
      })
    },
    checkSave() {
      if (!this.isAdmin && this.form.ifFba) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.canNotEditFbaWarehouse'))
        return false
      }
      if (!this.form.warehouseCode) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.warehouseNoEmpty'))
        return false
      }
      if (this.form.warehouseCode.length > 16) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.warehouseNoLen'))
        return false
      }
      if (!this.form.countryCode) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.countryNoEmpty'))
        return false
      }
      if (!this.form.cityCode) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.cityNoEmpty'))
        return false
      }
      if (!this.form.zipCode) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.zipCodeNoEmpty'))
        return false
      }
      if (!this.form.address1) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.addressNoEmpty'))
        return false
      }
      if (!this.form.countryChineseName && !this.isAdmin) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.chineseNameNoEmpty'))
        return false
      }
      if (!this.form.countryEnglishName && !this.isAdmin) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.englishNameNoEmpty'))
        return false
      }
      if (!(typeof this.form.warehouseAgeCalculationRules === 'number') && !this.form.warehouseAgeCalculationRules && !this.isAdmin) {
        this.$message.warning(this.$t('baseInfo.overseaWarehouse.msg.warehouseAgeCalculationRulesNoEmpty'))
        return false
      }
      return true
    }
  }
}
</script>

<style>
.station-edit-dialog .el-input-number .el-input input {
  text-align: right;
}
</style>
